const FormatDateTime = (datetime) => {
    if (!datetime) return "N/A"; // Handle cases where datetime is null or undefined

    return new Date(datetime).toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    }).replace(',', ' -');
};

export default FormatDateTime